import React, {useEffect, useMemo, useState} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import {useSelector} from "react-redux";
import {store} from "react-notifications-component";
import Cookies from "js-cookie";
import client from "../../lib/api/client";
import {styled} from "@material-ui/core";
import {withRouter} from "react-router-dom";

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center" style={{color: 'white', margin: '20px 0'}}>
            {'Copyright © '}
            <Link color="inherit" href="https://material-ui.com/">
                EY
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const useStyles = makeStyles(theme => ({
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
            height: '100%',
        },
    },
    container: {
        marginTop: '40px',
        width: '100%',
        height: '100%',
        animation: `$smoothAppear 2000ms ${theme.transitions.easing.easeInOut}`
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    "@keyframes smoothAppear": {
        "from": {
            opacity: 0,
            transform: "translateY(30%)"
        },
        "to": {
            opacity: 1,
            transform: "translateY(0)"
        }
    }
}));

const ForgotPasswordForm = ({ stdYear, setStep, history }) => {
    const [corprInfoDiviNo, setCorprInfoDiviNo] = useState("");
    const [email, setEmail] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isErrorCorprCode, setIsErrorCorprCode] = useState(false);
    const [errorMsgCorprCode, setErrorMsgCorprCode] = useState("");
    const [isErrorUserId, setIsErrorUserId] = useState(false);
    const [errorMsgUserId, setErrorMsgUserId] = useState("");
    const classes = useStyles();

    useEffect(() => {
        if (errorMessage) {
            store.addNotification({
                title: "알림",
                message: errorMessage,
                type: 'warning',
                insert: "top",
                container: "top-center",
                animationIn: ["animated", "flipInY"],
                animationOut: ["animated", "flipOutY"],
                dismiss: {
                    duration: 3000,
                    onScreen: false
                },
                width: 500
            });
        }
    }, [errorMessage])

    const onChange = e => {
        const { value, name } = e.target;

        if (name === "corprInfoDiviNo") {
            if (value.length <= 8) {
                setCorprInfoDiviNo(value);
                setIsErrorCorprCode(false);
                setErrorMsgCorprCode("");
            }
        } else if (name === "email") {
            if (value.length <= 50) {
                setEmail(value);
                setIsErrorUserId(false);
                setErrorMsgUserId("");
            }
        }
    };

    const emailCheck = (email) => {
        const regex=/([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        return (email !== '' && email !== 'undefined' && regex.test(email));
    }

    const onSubmit = e => {
        e.preventDefault();

        if (corprInfoDiviNo === "") {
            setIsErrorCorprCode(true);
            setErrorMsgCorprCode("법인번호를 입력하세요.");
        }

        if (email === "") {
            setIsErrorUserId(true);
            setErrorMsgUserId("이메일을 입력하세요.");
        }

        if (corprInfoDiviNo === "" || email === "") {
            return false;
        }

        if (!emailCheck(email)) {
            setIsErrorUserId(true);
            setErrorMsgUserId("올바른 이메일 형식으로 입력하세요.");
            return false;
        }

        setErrorMessage("");
        client.post('/kognr/resetPassword', {
            stdYear,
            corprInfoDiviNo,
            email
        }).then(response => {
            const { success, payload, error } = response.data;
            if (success) {
                store.addNotification({
                    title: "알림",
                    message: payload,
                    type: 'success',
                    insert: "top",
                    container: "top-center",
                    animationIn: ["animated", "flipInY"],
                    animationOut: ["animated", "flipOutY"],
                    dismiss: {
                        duration: 3500,
                        onScreen: false
                    },
                    width: 500
                });

                setStep("LOGIN");
            } else {
                setErrorMessage(error.message);
            }
        }).catch((error) => {
            console.log(error.response);
            const {status, data} = error.response;
            if (status !== 200) {
                setErrorMessage(data.payload);
            }
        });
    };

    const PasswordTextField = useMemo(() => {
        return styled(TextField)({
            '& label.MuiInputLabel-root': {
                color: 'white',
            },
            '& label.Mui-focused': {
                color: 'white',
            },
            '& .MuiInput-underline:after': {
                borderBottomColor: 'white',
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: 'white',
                },
                '&:hover fieldset': {
                    borderColor: 'yellow',
                },
                '&.Mui-focused fieldset': {
                    borderColor: 'white',
                },
            },
            '& input': {
                color: 'white',
            },
        });
    }, []);

    return (
        <>
            <CssBaseline />
            <Container component="main" maxWidth="xs" className={classes.container}>
                <div className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5" style={{color: 'white'}}>
                        로그인
                    </Typography>
                    <form className={classes.form} noValidate onSubmit={onSubmit}>
                        <PasswordTextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            size="small"
                            label="법인번호"
                            name="corprInfoDiviNo"
                            autoFocus
                            autoComplete="off"
                            error={isErrorCorprCode}
                            helperText={errorMsgCorprCode}
                            onChange={onChange}
                            value={corprInfoDiviNo}
                        />
                        <PasswordTextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            size="small"
                            label="이메일"
                            name="email"
                            autoComplete="off"
                            error={isErrorUserId}
                            helperText={errorMsgUserId}
                            onChange={onChange}
                            value={email}
                        />
                        {/*<PasswordTextField*/}
                        {/*    variant="outlined"*/}
                        {/*    margin="normal"*/}
                        {/*    required*/}
                        {/*    fullWidth*/}
                        {/*    size="small"*/}
                        {/*    name="newRePassword"*/}
                        {/*    label="새 비밀번호 재입력"*/}
                        {/*    type="password"*/}
                        {/*    error={errorMsgNewRePassword !== ""}*/}
                        {/*    helperText={errorMsgNewRePassword}*/}
                        {/*    onChange={onChange}*/}
                        {/*    value={newRePassword}*/}
                        {/*/>*/}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                        >
                            비밀번호 요청
                        </Button>
                        <Box>
                            <Link href="#" style={{ color: "#91fffb"}} onClick={() => setStep("LOGIN")}>
                                로그인
                            </Link>
                        </Box>
                    </form>
                    <Box>
                        <Copyright />
                    </Box>
                </div>

            </Container>
        </>
    );
};

export default withRouter(ForgotPasswordForm);

